import enrollmentsSlice from './enrollments';
import plansSlice from './plans';


export default {
  plansSlice,
  enrollmentsSlice,
};
